module.exports = __webpack_public_path__ + "img/icon-marker.718d0a4e.svg";